import React, { Suspense } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useInViewport } from '../hooks/useInViewport';

interface LazyMountProps {
  children: React.ReactNode;
  minHeight?: number | string;
  rootMargin?: string;
  fallback?: React.ReactNode;
}

const LazyMount: React.FC<LazyMountProps> = ({
  children,
  minHeight = 120,
  rootMargin = '300px',
  fallback = (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress size={28} sx={{ color: '#35bcb3' }} />
    </Box>
  ),
}) => {
  const [ref, isInView] = useInViewport<HTMLDivElement>({ rootMargin });

  return (
    <Box ref={ref} sx={{ minHeight }}>
      {isInView ? (
        <Suspense fallback={fallback}>{children}</Suspense>
      ) : null}
    </Box>
  );
};

export default LazyMount;
